import { cegidIntegrationRejectionCodeToTooltipTranslationKeys } from '@features/cegidIntegration/constants/cegidIntegrationStatusToTranslationKeys'

// Cegid owns this vocabulary and rest-invoice passes it through as an opaque string, so this
// is a partial lookup rather than an exhaustive map: an unrecognised code falls back to the
// generic Failed tooltip. The shared entries are spread in so the five reasons expenses
// already has copy for cannot drift, and so any reason it adds later arrives here for free.
//
// The value type is `string | undefined` deliberately: the repo does not enable
// `noUncheckedIndexedAccess`, so a bare `Record<string, string>` would type a miss as
// `string` and make the `??` fallback look dead to the reader.
export const importedInvoiceRejectCodeToTooltipKey: Record<string, string | undefined> = {
  ...cegidIntegrationRejectionCodeToTooltipTranslationKeys,
  INVALID_COLLECTION_DATE: 'cegid_integration_status.rejected_reasons.invalid_collection_date.tooltip',
  INVALID_DOCUMENT_TYPE: 'cegid_integration_status.rejected_reasons.invalid_document_type.tooltip',
  TOO_LARGE: 'cegid_integration_status.rejected_reasons.too_large.tooltip',
}
